export { default } from './ViewCompositionLegal';
